import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const directPutawayDetailRolesRBAC = {
  pageID: '0c184e3a0ce1834a42d77830022859dc',
  elementID: {
    ViewPutawayList: 'b6d8427e37ac620a2edd827863820080',
    BtnUnassignStaff: '8efe48d35029e0b8139f683ace1a752c',
  },
} as const

export const useRBACDirectPutawayDetailPage = createUseRBAC(directPutawayDetailRolesRBAC.elementID)

export type UseRBACDirectPutawayDetailPageType = ReturnType<typeof useRBACDirectPutawayDetailPage>
